import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { useOnClickOutside } from 'hooks';
import UiIcon from '../ui-icon/UiIcon';
import Feedback from '../../components/feedback/Feedback';
import { StyledDialog } from './UiDialog.styles';

const style = {
  root: {
    '@global': {
      '.MuiPaper-rounded': {
        borderRadius: '8px',
      },
      '.MuiPaper-root': {
        backgroundColor: '#fffff',
        maxWidth: '700px',
      },
      '.ui-dialog-title': {
        boxSizing: 'border-box',
        height: '48px',
        paddingBottom: '12px',
        paddingTop: '12px',
        '& .MuiTypography-root': {
          fontFamily: 'inherit !important',
          fontSize: '0.875rem !important',
          fontWeight: '800 !important',
        },
      },
      '.MuiTypography-root': {
        display: 'flex',
        justifyContent: 'space-between',
      },
      '.ui-dialog-actions': {
        paddingRight: '20px',
        paddingLeft: '20px',
        paddingBottom: '20px',
        borderRadius: '8px',
      },
      '.ui-dialog-content': {
        padding: '20px',
        paddingTop: '18px !important',
        borderRadius: '8px',
      },
    },
  },
  paper: (props) => ({ ...props?.customstyle?.paper, overflowY: 'unset' }),
};

const UiDialog = (props) => {
  const { support, children, className, ...restProps } = props;
  const [openSupport, setOpenSupport] = useState(false);
  const wrapperRef = useRef(null);

  const handelToggle = () => setOpenSupport(!openSupport);

  useOnClickOutside(wrapperRef, () => setOpenSupport(false));

  return (
    <StyledDialog
      className={classNames(props.classes.root, 'ui-dialog', 'card', className)}
      maxWidth='sm'
      fullWidth
      {...restProps}
    >
      {support && (
        <div
          className={`dialog-support pointer ${support} hide-in-mobile-size`}
          ref={wrapperRef}
          data-testid='dialog-support'
        >
          <UiIcon
            icon='ri-customer-service-2-line'
            color='#199DA3'
            hover='#116d72'
            className='p-13'
            size={20}
            onClick={handelToggle}
          />
          <div
            className={`container ${openSupport && 'open'}`}
            data-testid='dialog-support-modal'
          >
            <Feedback toggleHamburger={handelToggle} />
          </div>
        </div>
      )}
      {children}
    </StyledDialog>
  );
};

UiDialog.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  'classes.root': PropTypes.string,
  children: PropTypes.node,
  customstyle: PropTypes.any,
  support: PropTypes.bool,
};

export default withStyles(style)(UiDialog);
